// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginLayout_container__3yGru","logo":"LoginLayout_logo__2Mb2e","title":"LoginLayout_title__2_mVO"};